export default "__VITE_ASSET__z6NDFTf5__"